import { render } from "./HealthLight.vue?vue&type=template&id=1327d6c2"
import script from "./HealthLight.vue?vue&type=script&lang=js"
export * from "./HealthLight.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__